import { API } from "../../api";

const SETTINGS_URL = "/cooperatives/settings/member-referrals";
const INVITES_URL = "/cooperatives/referrals/invites";

export const memberReferralStaffApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getMemberReferralSettings: builder.query({
      query: () => `${SETTINGS_URL}?guard=staff`,
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "MemberReferralSettings", id: "CURRENT" }],
    }),
    updateMemberReferralSettings: builder.mutation({
      query: (body) => ({
        url: `${SETTINGS_URL}/update?guard=staff`,
        method: "POST",
        body,
      }),
      transformResponse: (responseData) => responseData,
      invalidatesTags: [{ type: "MemberReferralSettings", id: "CURRENT" }],
    }),
    getStaffReferralInvites: builder.query({
      query: ({ page = 1, limit = 20, search = "" } = {}) => {
        const params = new URLSearchParams({
          guard: "staff",
          page: String(page),
          limit: String(limit),
        });
        if (search) params.set("search", search);
        return `${INVITES_URL}?${params.toString()}`;
      },
      transformResponse: (responseData) => responseData?.data,
      providesTags: [{ type: "StaffReferralInvites", id: "LIST" }],
    }),
  }),
});

export const {
  useGetMemberReferralSettingsQuery,
  useUpdateMemberReferralSettingsMutation,
  useGetStaffReferralInvitesQuery,
} = memberReferralStaffApi;
